import { z } from "zod";
export const inboxStatusEnum = z.enum([
    "unread",
    "read",
    "archived",
    "spam",
    "processed",
]);
export const updateInboxMessageSchema = z
    .object({
    status: inboxStatusEnum.optional(),
    linked_expense_id: z.string().uuid().nullable().optional(),
    linked_ap_invoice_id: z.string().uuid().nullable().optional(),
})
    .strict()
    .refine((v) => Object.keys(v).length > 0, {
    message: "At least one field must be provided",
});
export const bulkUpdateInboxMessagesSchema = z
    .object({
    ids: z.array(z.string().uuid()).min(1).max(500),
    status: inboxStatusEnum,
})
    .strict();
//# sourceMappingURL=inbox.js.map